import { render, staticRenderFns } from "./flowPane.vue?vue&type=template&id=52674a24"
import script from "./flowPane.vue?vue&type=script&lang=js"
export * from "./flowPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports